module.exports = __webpack_public_path__ + "img/oBKMD_OO_400x400_v01.b810476c.jpg";